export var practitionersH1 = [
    {
        firstName: "Astride",
        lastName: "Hervé",
        email: "astride.herve@email.com",
        tel: "+33 476121489"
    },
    {
        firstName: "Florio",
        lastName: "Medina Cárdonas",
        email: "florio.medinacardonas@email.com",
        tel: "+33 476673441"
    },
    {
        firstName: "Yao",
        lastName: "Kouassi",
        email: "yao.kouassi@email.com",
        tel: "+33 476895467"
    }
]

export var practitionersH2 = [
    {
        firstName: "John",
        lastName: "Hobbs",
        email: "john.hobbs@email.com",
        tel: "+44 7911 123456"
    },
    {
        firstName: "Xue",
        lastName: "Liang",
        email: "xue.liang@email.com",
        tel: "+44 6533 654321"
    }
]